import React from 'react';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleResetAndReload = () => {
    try {
      localStorage.removeItem('himalayan_cms_content');
    } catch (e) {}
    window.location.href = window.location.origin + window.location.pathname;
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-pansar-950 text-white flex items-center justify-center p-4 font-sans dir-rtl">
          <div className="max-w-md w-full bg-pansar-900 border border-emerald-800/80 rounded-3xl p-6 sm:p-8 text-center shadow-2xl space-y-5">
            <div className="w-16 h-16 bg-amber-500/20 border border-amber-500/40 rounded-2xl flex items-center justify-center mx-auto text-amber-400">
              <AlertTriangle className="w-8 h-8" />
            </div>

            <div className="space-y-2">
              <h2 className="text-xl font-bold font-urdu text-white">
                معذرت! ایک غیر متوقع مسئلہ پیش آیا ہے
              </h2>
              <p className="text-xs text-emerald-200/80 font-urdu leading-relaxed">
                صفحہ دوبارہ لوڈ کریں یا مواد کی ترتیبات ری سیٹ کر کے دوبارہ کوشش کریں۔
              </p>
            </div>

            <div className="flex flex-col gap-3 pt-2">
              <button
                onClick={this.handleReload}
                className="w-full py-3 px-4 rounded-xl bg-amber-500 hover:bg-amber-400 text-slate-950 font-bold font-urdu text-sm transition flex items-center justify-center gap-2 cursor-pointer shadow-md"
              >
                <RefreshCw className="w-4 h-4" />
                <span>صفحہ دوبارہ لوڈ کریں (Reload)</span>
              </button>

              <button
                onClick={this.handleResetAndReload}
                className="w-full py-2.5 px-4 rounded-xl bg-white/10 hover:bg-white/20 text-emerald-100 font-medium font-urdu text-xs transition flex items-center justify-center gap-2 cursor-pointer"
              >
                <Home className="w-4 h-4 text-emerald-400" />
                <span>ہوم پیج پر جائیں اور ترتیبات درست کریں</span>
              </button>
            </div>

            {this.state.error && (
              <details open className="text-left text-[11px] text-rose-300 bg-black/70 p-3 rounded-xl overflow-auto max-h-60 dir-ltr font-mono select-all">
                <summary className="cursor-pointer font-bold mb-1 text-rose-400">Error details & stack:</summary>
                <div className="whitespace-pre-wrap">
                  {this.state.error?.toString()}
                  {'\n\n'}
                  {this.state.error?.stack}
                </div>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
